import React, { useState, useEffect } from 'react';
import { Container, Button, Table, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import creditCardService from '../services/creditCardService';

const CreditCards = () => {
  const navigate = useNavigate();
  const [creditCards, setCreditCards] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadCreditCards = async () => {
    try {
      setLoading(true);
      const data = await creditCardService.getAll();
      setCreditCards(data);
    } catch (error) {
      console.error('Erro ao carregar cartões de crédito:', error);
      toast.error('Erro ao carregar cartões de crédito. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCreditCards();
  }, []);

  const handleEdit = (id) => {
    navigate(`/credit-cards/${id}`);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este cartão de crédito?')) {
      try {
        await creditCardService.delete(id);
        toast.success('Cartão de crédito excluído com sucesso!');
        loadCreditCards();
      } catch (error) {
        console.error('Erro ao excluir cartão de crédito:', error);
        toast.error('Erro ao excluir cartão de crédito. Tente novamente.');
      }
    }
  };

  const getBrandLabel = (brand) => {
    const labels = {
      'VISA': 'Visa',
      'MASTERCARD': 'Mastercard',
      'ELO': 'Elo',
      'AMEX': 'Amex',
      'OUTRO': 'Outro'
    };
    return labels[brand] || brand;
  };

  const getStatusBadge = (status) => {
    const variants = {
      'ACTIVE': 'success',
      'INACTIVE': 'warning',
      'CANCELLED': 'danger'
    };
    const labels = {
      'ACTIVE': 'Ativo',
      'INACTIVE': 'Inativo',
      'CANCELLED': 'Cancelado'
    };
    return (
      <Badge bg={variants[status] || 'secondary'}>
        {labels[status] || status}
      </Badge>
    );
  };

  return (
    <Container data-testid="credit-cards-page">
      <div className="sheet-container">
        <div className="sheet-header">
          <h5 className="sheet-title">Cartões de Crédito</h5>
          <div className="sheet-toolbar">
            <Button 
              className="excel-btn"
              data-testid="new-credit-card-button"
              onClick={() => navigate('/credit-cards/new')}
            >
              <FaPlus className="me-1" /> Novo Cartão
            </Button>
          </div>
        </div>
        
        <div className="p-3">
          <Table className="excel-table" data-testid="credit-cards-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Bandeira</th>
                <th>Número</th>
                <th>Fechamento</th>
                <th>Vencimento</th>
                <th>Status</th>
                <th style={{ width: '120px' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {creditCards.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center" data-testid="empty-message">
                    {loading ? 'Carregando...' : 'Nenhum cartão encontrado'}
                  </td>
                </tr>
              ) : (
                creditCards.map((card) => (
                  <tr key={card.id} data-testid="credit-card-row">
                    <td>{card.name}</td>
                    <td>{getBrandLabel(card.brand)}</td>
                    <td>{card.number ? `**** ${card.number}` : '-'}</td>
                    <td>{card.closingDay || '-'}</td>
                    <td>{card.dueDay || '-'}</td>
                    <td>{getStatusBadge(card.status)}</td>
                    <td>
                      <div className="d-flex gap-2">
                        <Button 
                          variant="outline-primary" 
                          size="sm"
                          className="me-2"
                          onClick={() => handleEdit(card.id)}
                        >
                          <FaEdit />
                        </Button>
                        <Button 
                          variant="outline-danger" 
                          size="sm"
                          onClick={() => handleDelete(card.id)}
                        >
                          <FaTrash />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </Container>
  );
};

export default CreditCards; 